import { useEffect, useState } from "react";

import "./App.scss";

import ImagesLoaded from "./components/ImagesLoaded/ImagesLoaded";
import BuildContext from "./contexts/BuildContext/BuildContext";
import Part1 from "./components/Part1/Part1";
import ScrollDown from "./components/ScrollDown/ScrollDown";
import ShowUIHelpers from "./components/ShowUIHelpers/ShowUIHelpers";
import ResetButton from "./components/ResetButton/ResetButton";
import Loader from "./components/Loader/Loader";
import SeeAllButton from "./components/SeeAllButton/SeeAllButton";
import ProgressBar from "./components/ProgressBar/ProgressBar";
import Footer from "./components/Footer/Footer";
// import Spacer from "./components/Spacer/Spacer.jsx";
import { setCssVariable } from "./utils/setCssVariable";
import Part2 from "./components/Part2/Part2";
import Part3 from "./components/Part3/Part3";
import Part4 from "./components/Part4/Part4";
import Part5 from "./components/Part5/Part5";
import Part6 from "./components/Part6/Part6";
import Part7 from "./components/Part7/Part7";
import Part8 from "./components/Part8/Part8";
import SkipLink from "./components/SkipLink/SkipLink";

function App() {
  const [loading, setLoading] = useState(true);
  const [buildEnv, setBuildEnv] = useState(null);
  const [showScrolldown, setShowScrolldown] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [numImagesLoaded, setNumImagesLoaded] = useState(0);
  const [numberOfImages, setNumberOfImages] = useState(null);

  // sets the build environment variable and loads the "scroll down" element
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      setBuildEnv("development");
    } else {
      window.onbeforeunload = function () {
        window.scrollTo(0, 0);
      };
      window.scrollTo(0, 0);
      setBuildEnv("production");
      setTimeout(() => {
        setLoading(false);
        setShowScrolldown(true);
      }, 2250);
    }
  }, []);

  // Checks to see if all images have been loaded, changes imagesLoaded state to true when all have been loaded
  useEffect(() => {
    if (numImagesLoaded === numberOfImages) {
      setImagesLoaded(true);
    }
  }, [numImagesLoaded, numberOfImages]);

  // set window height upon load.  Update window height if the page is resized
  useEffect(() => {
    updateWindowHeight();
    window.addEventListener("resize", updateWindowHeight, false);
  }, []);

  // Sets the CSS variable var(--window-height) to the current window height
  const updateWindowHeight = () => {
    const windowHeight = window.innerHeight;
    setCssVariable("--window-height", `${windowHeight}px`);
  };

  return (
    <BuildContext.Provider value={{ buildEnv }}>
      <ImagesLoaded
        setNumImagesLoaded={setNumImagesLoaded}
        setNumberOfImages={setNumberOfImages}
      />
      {showScrolldown && <ScrollDown />}
      {loading && !imagesLoaded && buildEnv === "production" && (
        <Loader
          numberOfImages={numberOfImages}
          numImagesLoaded={numImagesLoaded}
        />
      )}
      <SkipLink />
      <ProgressBar />
      <SeeAllButton />
      <main>
        <div className="container">
          <Part1 step={"step1"} />
          <Part2 step={"step2"} />
          <Part3 step={"step3"} />
          <Part4 step={"step4"} />
          <Part5 step={"step5"} />
          <Part6 step={"step6"} />
          <Part7 step={"step7"} />
          <Part8 step={"step8"} />
          <Footer />
          {buildEnv === "development" && <ShowUIHelpers />}
          {buildEnv === "development" && <ResetButton />}
        </div>
      </main>
    </BuildContext.Provider>
  );
}

export default App;
